import standardAPI from '@/api/standard_items';

const responseUrl = '/excursion/categories/types';

const state = {
  excursion_categories_types: [],
  excursion_categories_types_status: '',
  excursion_categories_types_MetaData: {},
  excursion_categories_types_page: 1,
  excursion_categories_types_perPage: 10,
};

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_excursion_categories_types ({ commit }, getOptions) {
    commit('EXCURSION_CATEGORIES_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('EXCURSION_CATEGORIES_TYPES_SUCCESS', response);
            commit('EXCURSION_CATEGORIES_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('EXCURSION_CATEGORIES_TYPES_READY');
            reject(response);
          } else {
            commit('EXCURSION_CATEGORIES_TYPES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },

  fetch_excursion_categories_types_union ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl + '/union',
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          reject(response);
        }
      }, preparedOptions);
    });
  },

  add_excursion_categories_type ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_TYPES_READY');
          reject(response);
        }
      });
    });
  },

  edit_excursion_categories_type ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_TYPES_READY');
          reject(response);
        }
      });
    });
  },

  remove_excursion_categories_type ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_TYPES_READY');
          reject(response);
        }
      });
    });
  },

  reorder_excursion_categories_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        // console.log(response)
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.excursion_categories_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.excursion_categories_types_perPage = max;
  },
  EXCURSION_CATEGORIES_TYPES_REQUEST: (state) => {
    state.excursion_categories_types_status = 'loading';
  },
  EXCURSION_CATEGORIES_TYPES_READY: (state) => {
    state.excursion_categories_types_status = 'ready';
  },
  EXCURSION_CATEGORIES_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.excursion_categories_types_MetaData.meta = response.meta;
      state.excursion_categories_types_MetaData.links = response.links;
    }
    state.excursion_categories_types = response.data;
    state.excursion_categories_types_status = 'success';
  },
  EXCURSION_CATEGORIES_TYPES_ERROR: (state) => {
    state.excursion_categories_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
